import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/core/auth/useAuth';
import type { Role } from '@/core/auth/AuthContext';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { firebaseUser, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullPageSpinner />;
  if (!firebaseUser) return <Navigate to="/login" state={{ from: location }} replace />;
  return <>{children}</>;
}

export function RequireRole({
  roles,
  children,
  fallback,
}: {
  roles: Role[];
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const { user, loading } = useAuth();
  if (loading) return <FullPageSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <>{fallback ?? <Forbidden />}</>;
  return <>{children}</>;
}

function FullPageSpinner() {
  return (
    <div className="flex h-full items-center justify-center text-content-subtle">
      <span className="animate-pulse">Cargando…</span>
    </div>
  );
}

function Forbidden() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 p-6 text-center">
      <h1 className="text-xl font-semibold">Sin acceso</h1>
      <p className="text-content-subtle">
        Tu rol no tiene permiso para ver esta sección.
      </p>
    </div>
  );
}
